
export default {
  props: {
    result: {
      // 后缀
      type: Array,
      default: () => []
    },
    prefixesarr: {
      // 前缀
      type: Array,
      default: () => []
    },
    goodregulatory: {
      // 监管评分是否大于5为true小于5为false
      type: Boolean,
      default: false
    },
    addtradertype: {
      // 1加入还是2认领3认证
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      hzemail: '', // 后缀
      prefixeemail: '' // 前缀选择
    }
  },
  watch: {
    hzemail(newval, oldval) {
      console.log(this.hzemail, 909)
      this.$emit('sethzemail', this.prefixeemail, newval)
    },
    prefixeemail(newval, oldval) {
      this.$emit('sethzemail', this.prefixeemail, this.hzemail)
    }
  }
}
